export default __webpack_public_path__ + "261d4cbdca27c26039aa9ff3d4fc310b.webp";